export const buyBonusType = {
  GET_BUY_BONUS_LIST_REQUEST: "GET_BUY_BONUS_LIST_REQUEST",
  GET_BUY_BONUS_LIST_SUCCESS: "GET_BUY_BONUS_LIST_SUCCESS",
  GET_BUY_BONUS_LIST_FAIL: "GET_BUY_BONUS_LIST_FAIL"
};
